var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.02647 12.7175L3.59961 9.20375L11.976 0.614578L15.4029 4.12833L7.02647 12.7175ZM5.55721 9.20375L7.02647 10.7103L13.4457 4.12833L11.9764 2.62181L5.55721 9.20375Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2917 4.24067L14.3131 3.23686C14.7182 2.82145 14.7182 2.14576 14.3131 1.73034C13.908 1.31493 13.249 1.31533 12.8438 1.73034L11.8652 0.726526C12.8102 -0.242374 14.3472 -0.241977 15.2921 0.726526C16.2367 1.69543 16.2367 3.27177 15.2917 4.24067Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.90742 13.3857C3.65628 13.3857 3.4125 13.2841 3.23141 13.0984C3.00814 12.8695 2.90946 12.5425 2.9675 12.2243L3.368 10.0314C3.37303 10.004 3.37574 9.98341 3.37652 9.96952C3.3978 9.60291 3.54871 9.25892 3.80139 8.99983L4.57878 8.20312L8.00564 11.7169L7.22825 12.514C6.98796 12.7604 6.66988 12.9135 6.33168 12.9457C6.25623 12.9528 6.17458 12.9675 6.11189 12.9794L4.08387 13.3686C4.02505 13.3801 3.96585 13.3857 3.90742 13.3857ZM4.7177 10.3528L4.44335 11.8561L5.85728 11.5848C5.87392 11.5816 5.89133 11.5784 5.90951 11.5748L4.7177 10.3528Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.8927 16.0035H2.71874C1.21968 16.0035 0 14.7529 0 13.2158V4.83455C0 3.29748 1.21968 2.04688 2.71874 2.04688H7.71779V3.20821H2.71874C1.84422 3.20821 1.13261 3.93786 1.13261 4.83455V13.2158C1.13261 14.1125 1.84422 14.8422 2.71874 14.8422H10.8927C11.7673 14.8422 12.4789 14.1125 12.4789 13.2158V8.43479H13.6115V13.2158C13.6115 14.7529 12.3918 16.0035 10.8927 16.0035Z",
    fill: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.965dbcce52288c165cf3ea19109e226b.svg";
export { ForwardRef as ReactComponent };